var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.435,
    height: 32,
    viewBox: "0 0 26.435 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.885 4.637H4.637A3.246 3.246 0 0 0 1.391 7.885v19.478A3.246 3.246 0 0 0 4.637 30.609H20.87a3.246 3.246 0 0 0 3.246 -3.246v-19.478A3.246 3.246 0 0 0 20.87 4.637h-3.246",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.376 1.391H11.131a3.246 3.246 0 0 0 0 6.493h3.246a3.246 3.246 0 1 0 0 -6.493ZM7.885 24.116V16Zm4.87 0v-1.622Zm4.87 0v-4.87Z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.131 2.783a1.855 1.855 0 0 0 0 3.711h3.246a1.855 1.855 0 1 0 0 -3.711H11.131Zm-4.424 0.463A4.64 4.64 0 0 1 11.131 0h3.246c2.077 0 3.834 1.363 4.426 3.246H20.87a4.637 4.637 0 0 1 4.637 4.639v19.478A4.637 4.637 0 0 1 20.87 32H4.637A4.637 4.637 0 0 1 0 27.363v-19.478a4.637 4.637 0 0 1 4.637 -4.639H6.706Zm12.096 2.783a4.64 4.64 0 0 1 -4.424 3.247H11.131a4.64 4.64 0 0 1 -4.424 -3.247H4.636A1.855 1.855 0 0 0 2.783 7.885v19.478A1.855 1.855 0 0 0 4.637 29.218H20.87a1.855 1.855 0 0 0 1.855 -1.855v-19.478A1.855 1.855 0 0 0 20.87 6.029h-2.067ZM7.885 14.609a1.391 1.391 0 0 1 1.391 1.391v8.116a1.391 1.391 0 1 1 -2.783 0V16a1.391 1.391 0 0 1 1.391 -1.391Zm9.739 3.246a1.391 1.391 0 0 1 1.391 1.391v4.87a1.391 1.391 0 0 1 -2.783 0v-4.87a1.391 1.391 0 0 1 1.391 -1.391Zm-4.87 3.247a1.391 1.391 0 0 1 1.391 1.391v1.622a1.391 1.391 0 0 1 -2.783 0v-1.622a1.391 1.391 0 0 1 1.391 -1.391Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.6efa873c.svg";
export { ForwardRef as ReactComponent };